import { Reveal } from "./Reveal";
import { ShieldCheck, Stethoscope, ArrowUpRight } from "lucide-react";

const BENTO_IMG =
  "https://images.unsplash.com/photo-1634055739897-b6a98a80114a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxkcml2ZXIlMjBoYXBweSUyMGNhciUyMHBvcnRyYWl0fGVufDB8fHx8MTc4OTE2MzY3NHww&ixlib=rb-4.1.0&q=85";

export default function Bento() {
  return (
    <section data-testid="benefits-section" className="mx-auto max-w-7xl px-5 pb-28 sm:px-8 sm:pb-36">
      <Reveal>
        <p className="font-mono-x text-xs uppercase tracking-[0.35em] text-[#34d186]">Porquê o Grupo IFT</p>
        <h2 className="mt-4 max-w-3xl font-display text-2xl font-bold tracking-tight text-[#171717] sm:text-3xl lg:text-4xl">
          Tudo o que precisas para chegar à estrada.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-8 lg:grid-cols-12">
        <Reveal className="md:col-span-8 lg:col-span-8" delay={0.05}>
          <div
            data-testid="bento-card-main"
            className="group relative h-full overflow-hidden rounded-3xl border border-[#34d186]/20 bg-[#f5f5f5] p-8 transition-colors duration-500 hover:border-[#34d186]/50 sm:p-10"
          >
            <img
              src={BENTO_IMG}
              alt="Motorista satisfeito"
              className="absolute inset-0 h-full w-full object-cover opacity-25 transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#f5f5f5] via-[#f5f5f5]/85 to-transparent" />
            <div className="relative">
              <ShieldCheck size={30} className="text-[#34d186]" />
              <h3 className="mt-6 max-w-md font-display text-xl font-bold text-[#171717] sm:text-2xl">
                Formação certificada para obtenção do CMTVDE
              </h3>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-[#737373] sm:text-base">
                Formação oficial reconhecida pelo IMT para operares na plataforma Bolt em Portugal, com
                flexibilidade de horários laborais e pós-laborais.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal className="md:col-span-4 lg:col-span-4" delay={0.1}>
          <div
            data-testid="bento-card-medical"
            className="h-full rounded-3xl border border-black/10 bg-[#fafafa] p-8 transition-colors duration-500 hover:border-[#34d186]/50"
          >
            <Stethoscope size={26} className="text-[#34d186]" />
            <h3 className="mt-5 font-display text-lg font-bold text-[#171717] sm:text-xl">
              Exame médico e psicotécnico para averbamento do Grupo II
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-[#737373]">
              Marque connosco. Simples, rápido e sem deslocações desnecessárias.
            </p>
            <a
              href="https://consultas.grupoift.pt/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="bento-marcar-consulta-btn"
              className="group mt-6 inline-flex items-center gap-2 rounded-full bg-[#34d186] px-5 py-2.5 text-sm font-semibold text-[#ffffff] transition-all duration-300 hover:bg-[#00c46a] hover:shadow-[0_0_24px_rgba(52,209,134,0.4)]"
            >
              Marcar exame
              <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
          </div>
        </Reveal>

      </div>
    </section>
  );
}
